import apiClient from "@/api/client";

export type BackupType = "snapshot" | "full" | "incremental";

export interface BackupSchedule {
  id: number;
  vm_id: number;
  cron_expr: string;
  backup_type: BackupType;
  enabled: boolean;
  retention_policy_id: number | null;
  last_run_at: string | null;
  last_status: string | null;
  next_run_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface BackupScheduleCreate {
  vm_id: number;
  cron_expr?: string;
  backup_type?: BackupType;
  enabled?: boolean;
  retention_policy_id?: number | null;
}

export async function listBackupSchedules(): Promise<BackupSchedule[]> {
  const { data } = await apiClient.get<BackupSchedule[]>("/backups/schedules");
  return data;
}

export async function createBackupSchedule(
  payload: BackupScheduleCreate,
): Promise<BackupSchedule> {
  const { data } = await apiClient.post<BackupSchedule>(
    "/backups/schedules",
    payload,
  );
  return data;
}

export async function updateBackupSchedule(
  id: number,
  payload: Partial<BackupScheduleCreate>,
): Promise<BackupSchedule> {
  const { data } = await apiClient.patch<BackupSchedule>(
    `/backups/schedules/${id}`,
    payload,
  );
  return data;
}

export async function deleteBackupSchedule(id: number): Promise<void> {
  await apiClient.delete(`/backups/schedules/${id}`);
}

export async function runBackupScheduleNow(id: number): Promise<unknown> {
  const { data } = await apiClient.post(`/backups/schedules/${id}/run-now`);
  return data;
}
